<template>
  <ul class="pointData">
    <li :key="i" v-for="(data,i) in formatData">
      <el-table
        :data="data"
        border
        :style="{height: height}"
        style="width: 100%;overflow-y: auto"
      >
        <el-table-column
          align="center"
          label="监测指标"
          prop="pointName">
          <template slot-scope="scope">
            <span class="largeContent">{{ scope.row.pointName }}</span>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="值"
            prop="pointValueName">
          <template slot-scope="scope">
            <span class="largeContent">{{ scope.row.pointValueName }}{{ scope.row.pointValueName.indexOf(scope.row.pointUnit) !== -1?'': scope.row.pointUnit }}</span>
          </template>
        </el-table-column>
      </el-table>
    </li>
  </ul>
</template>

<script>
export default {
  name: "PointLayout",
  props: {
    pointData: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '241px'
    },
    number: {
      type: Number,
      default: 6,
    }
  },
  computed: {
    formatData() {
      const pages = [];
      this.pointData.forEach((item, index) => {
        const page = Math.floor(index / this.number)
        if (!pages[page]) {
          pages[page] = []
        }
        pages[page].push(item);
      })
      return pages
    }
  },
}
</script>

<style scoped>
ul.pointData {
  padding-left: 0;
}

.pointData li {
  width: 238px;
  list-style: none;
  display: inline-block;
  margin: 15px 10px;
}

.pointData .el-table >>> .el-table__header {
  font-size: inherit;
}

.pointData .el-table >>> .el-table__body-wrapper {
  font-size: 0.85rem;
}

.pointData .el-table >>> td, .pointData .el-table >>> th {
  padding: 5px 0;
}

.pointData .el-table--border, .pointData .el-table--group {
  border-left: none;
}

.pointData .el-table >>> .el-table__header-wrapper, .pointData .el-table >>> .el-table__body-wrapper {
  border-left: 1px solid rgba(41, 155, 255, .3);
  border-right: 1px solid rgba(41, 155, 255, .3);
}
</style>
